import React, { useEffect, useState } from "react";
import { Bike, MapPin, Star } from "lucide-react";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function Drivers() {
  const [drivers, setDrivers] = useState(null);
  useEffect(() => { api("/drivers/nearby").then((d) => setDrivers(Array.isArray(d) ? d : (d.drivers || []))).catch(() => setDrivers([])); }, []);
  if (!drivers) return <Loader />;
  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="السائقون القريبون" />
      {drivers.length === 0 ? <EmptyState icon={Bike} title="لا يوجد سائقون متاحون حالياً" /> : (
        <div className="space-y-3">
          {drivers.map((d) => (
            <div key={d.user_id} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2]">
              <div className="w-12 h-12 rounded-2xl bg-[#3F8CFF] text-white flex items-center justify-center"><Bike size={22} /></div>
              <div className="flex-1">
                <p className="font-black text-[#161629]">{d.name}</p>
                <div className="flex items-center gap-3 text-xs text-[#6B7280] mt-1">
                  {d.distance_km != null && <span className="flex items-center gap-1"><MapPin size={12} /> {d.distance_km} كم</span>}
                  {d.avg_rating != null && <span className="flex items-center gap-1"><Star size={12} /> {Number(d.avg_rating).toFixed(1)}</span>}
                  {d.driver_vehicle_type && <span>{d.driver_vehicle_type}</span>}
                </div>
              </div>
              {d.driver_active && <span className="text-xs font-black px-2 py-1 rounded-lg bg-[#D9F8E8] text-[#00D26A]">متصل</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
